import apiCommonCategory from "@/api/common-category";
import {post} from "@/utils/request";

export default class apiBkBook extends apiCommonCategory{
  static module = 'bk_book'

  static async listDel(ids){
    return post('/home/bk_book/listDel', {ids})
  }

  static async import(url){
    return post('/home/bk_book/import', {url})
  }

  static async testExport(){
    return post('/home/bk_book/testExport')
  }

  static async clearLibrary(){
    return post('/home/bk_book/clearLibrary')
  }

  static async downloadBookLibrary(supplierUid){
    return post('/home/bk_book/downloadBookLibrary', {supplierUid})
  }

  static async importStatus(){
    return post('/home/bk_book/importStatus')
  }
}
